<script setup lang="ts">
import Badge from '@/components/badge/Badge.vue';
import { BadgeColor, BadgeSize, BadgeVariant } from '@/hooks/useBadgeClasses';

const props = defineProps<{
  label: string;
  value?: string;
  icon: Component;
  badgeLabel?: string;
}>();

const rawIcon = toRaw(props.icon);
</script>

<template>
  <div class="flex items-start gap-x-2.5 text-md leading-5">
    <dt class="font-medium text-slate-500">
      <div class="flex items-center gap-x-2">
        <component v-if="icon" :is="rawIcon" class="h-4 w-4" />
        {{ label }}
      </div>
    </dt>
    <dd class="grow text-slate-900">
      <div class="flex items-center gap-x-2">
        {{ value ?? '--' }}
        <Badge
          v-if="badgeLabel"
          :color="BadgeColor.slate"
          :size="BadgeSize.sm"
          :variant="BadgeVariant.soft"
          >{{ badgeLabel }}</Badge
        >
      </div>
    </dd>
  </div>
</template>
